<nav
    class="sir-container"
    [style.--sir-nav-dropdown-col-count]="columns().length + (highlightItems()?.length ? 1 : 0)">
    @for (col of columns(); track $index) {
        <ol class="sir-col">
            @for (submenuItem of col; track $index) {
                <li class="sir-item">
                    <a
                        [siriusLink]="submenuItem.submenuLink"
                        (linkSelect)="onClick(submenuItem.submenuLink, $event)"
                        class="sir-title sir-text-style-paragraph-m-bold">
                        <span>{{ submenuItem.submenuTitle }}</span>
                    </a>
                    @if (submenuItem.submenuItems && submenuItem.submenuItems.length > 0) {
                        <ol class="sir-sub-items">
                            @for (subSubMenuItem of submenuItem.submenuItems; track $index) {
                                <li class="sir-item">
                                    <a
                                        [siriusLink]="subSubMenuItem.submenuLink"
                                        (linkSelect)="onClick(subSubMenuItem.submenuLink, $event)">
                                        <span>{{ subSubMenuItem.submenuTitle }}</span>
                                    </a>
                                </li>
                            }
                        </ol>
                    }
                </li>
            }
        </ol>
    }
    @let highlights = highlightItems();
    @if (highlights) {
        <ol class="sir-col">
            <li class="sir-item">
                @for (item of highlights; track $index) {
                    <a [siriusLink]="item.highlightItemLink" (linkSelect)="onClick(item.highlightItemLink, $event)">
                        <!-- TODO: Change to better suited dom elements -->
                        <span class="sir-title sir-text-style-paragraph-m-bold">{{ item.highlightItemTitle }}</span>
                        <p class="sir-highlight">{{ item.highlightItemText }}</p>
                    </a>
                }
            </li>
        </ol>
    }
</nav>
